import { render } from "./ExternalApp.vue?vue&type=template&id=43d4d95b&ts=true"
import script from "./ExternalApp.vue?vue&type=script&lang=ts"
export * from "./ExternalApp.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__